import * as React from "react";

const SvgRedCard = props => <svg width={19} height={24} viewBox="0 0 19 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M18.9766 0.25H0.555908V23.75H9.76625H18.9766V12V0.25Z" fill="#FC3256" /></svg>;

export default SvgRedCard;